import React from 'react';
import { useCommonAuth } from '../../contexts/CommonAuthContext';
import Unauthorized from './Unauthorized';

/**
 * AuthValidator — shell-first auth gate.
 *
 * While CommonAuthContext validates the session in the background, the
 * app chrome renders normally (the TopProgressBar in PageHeader is the
 * only loading signal — no full-screen "Validating authentication"
 * page). Data fetched by children before validation settles is safe:
 * an invalid session 401s through the api client's interceptor, which
 * redirects to login (auth-handler.redirectToLogin), and the validate
 * call itself redirects on failure. The Unauthorized branch is
 * belt-and-braces for the rare path where the context flips
 * isAuthenticated=false without redirecting.
 */
const AuthValidator = ({ children }) => {
  const { loading, isAuthenticated } = useCommonAuth();

  if (!loading && !isAuthenticated) {
    return <Unauthorized />;
  }

  return children;
};

export default AuthValidator;
